import { connectedStore } from '../../store';
import view from '../../view';
import getScrollPositions from './get-scroll-position';

const scrollHandler = (e) => {
  const store = connectedStore.get();
  if (e.isTrusted) {
    /**
     * For all normal devices scroll events dispatch
     * as expected, so we can extract current scroll position
     */
    const scrollPosition = getScrollPositions(e.target);
    store.dispatch(view.actions.setScrollPosition(scrollPosition));
  } else {
    /**
     * iPadOS Safari does not dispatch scroll events
     * in case when content height is changing
     * and Safari is adopting scroll to fit bottom side
     * of content into a view, so we trigger
     * the synthetic events in this case. Such event contains
     * `detail` section with `scrollPosition` property
     */
    const { scrollPosition } = e.detail;
    store.dispatch(view.actions.setScrollPosition(scrollPosition));
  }
};

export default scrollHandler;
